import React, { Component } from 'react';
class LoodingAssembly extends Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (
			<div>
				<div></div>
			</div>
		)
	}
}
export { LoodingAssembly }


// WEBPACK FOOTER //
// ./src/components/comAssembly.js